<template>
  <section class="section container pt-0">
    <api-datatable />
  </section>
</template>

<script>
import ApiDatatable from "./api_datatable/Index.vue";

export default {
  name: "ReportIndex",
  components: {
    ApiDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
